import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";
import { getPaginationUrl } from "../../utils/constants/GetPaginationURL";

const initialState = {
  loading: false,
  resData: {
    data: [],
    meta: {},
  },
  departments: [],
  AllTimeSlots: [],
  checkedShiftData: [],
  paymentStatus: {},
};

export const getAllTransportaionList = createAsyncThunk(
  "transportationSlice/getAllTransportaionList",
  async (dispatchParams) => {
    const { selectedDate, paginationData, selectedSlots } = dispatchParams;
    let slotFilter = "filters[slotName]=equals:";
    if (selectedSlots?.length > 0) {
      slotFilter += selectedSlots
        ?.map((name) => `${name}`)
        .join(encodeURIComponent("+"));
    }
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: "get",
      url: `transport/all-users/${paginationUrl}${
        selectedDate ? `&date=${selectedDate}` : ""
      }${selectedSlots?.length > 0 ? `&${slotFilter}` : ""}`,
    });
    return res;
  }
);

export const getAllTransportTimeSlots = createAsyncThunk(
  "transportationSlice/getAllTransportTimeSlots",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: "transport/all-slots",
    });
    return res;
  }
);

export const getCheckedShiftDetails = createAsyncThunk(
  "transportationSlice/getCheckedShiftDetails",
  async ({ shiftId, date }) => {
    const res = await apiRequest({
      method: "get",
      url: `transport/slot-details/${shiftId ? `${shiftId}` : ""}?date=${date}`,
    });
    return res;
  }
);

export const bookSeat = createAsyncThunk(
  "transportationSlice/bookSeat",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `transport/`,
      data: data,
    });
    return res;
  }
);

export const removeSeat = createAsyncThunk(
  "transportationSlice/removeSeat",
  async (id) => {
    const res = await apiRequest({
      method: "delete",
      url: `transport//${id}`,
    });
    return res;
  }
);
export const verifyPayment = createAsyncThunk(
  "transportationSlice/verifyPayment",
  async (userIds) => {
    const res = await apiRequest({
      method: "post",
      url: `transport/verify-users`,
      data: userIds,
    });
    return res;
  }
);

export const getPaymentStatus = createAsyncThunk(
  "transportationSlice/getPaymentStatus",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `transport/get-payment-status`,
    });
    return res;
  }
);

export const revertStatus = createAsyncThunk(
  "transportationSlice/revertStatus",
  async (id) => {
    const res = await apiRequest({
      method: "patch",
      url: `transport/revert-status/${id}`,
    });
    return res;
  }
);

const trasportationSlice = createSlice({
  name: "transportationSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //..................GETING ALL TRANSPORTAIIONLIST................
    builder.addCase(getAllTransportaionList.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getAllTransportaionList.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        resData: {
          ...state.resData,
          data: action?.payload?.data,
          meta: action?.payload?.meta,
        },
      };
    });

    //..................GETING ALL TRANSPORTAION TIME SLOTS................
    builder.addCase(getAllTransportTimeSlots.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getAllTransportTimeSlots.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        AllTimeSlots: action.payload.data,
      };
    });

    //..................GETING ALL DETAILS OF SELECTED SHIFT AND ALSO GET THE DETAILS THAT WHETHER THE USER ALREADY BOOKED SEAT OR NOT...............
    builder.addCase(getCheckedShiftDetails.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getCheckedShiftDetails.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        checkedShiftData: action.payload.data,
      };
    });

    //..................EMPLOYE BOOKING THE CAB...............
    builder.addCase(bookSeat.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(bookSeat.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });

    //..................EMPLOYE REMOVING THE CAB...............
    builder.addCase(removeSeat.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(removeSeat.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------verifyPayment--------------------
    builder.addCase(verifyPayment.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(verifyPayment.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // --------------------getPaymentStatus------------------

    builder.addCase(getPaymentStatus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getPaymentStatus.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        paymentStatus: data,
        loading: false,
      };
    });
    // ----------------revertStart----------------------------
    builder.addCase(revertStatus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(revertStatus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

//   export const {  } = trasportationSlice.actions
export default trasportationSlice.reducer;
